/* In this file you will define and export the constants that will identify all the possible action types. You can have individual files to group actions, but you should export all of them through this file. */



//An example action type
export const EXAMPLE_ACTION_TYPE="EXAMPLE_ACTION_TYPE";